import type Swiper from 'swiper';
import { getSwiperOptions } from './swiper-options';
import { initSwiper } from './swiper.ts';

export function initCarousel(element: HTMLElement) {
  initSwiper(element, getSwiperOptions(element.dataset.carouselName ?? 'default'));
}

export function initProductCarousel() {
  const galleryCarouselElement = document.querySelector<HTMLElement>('.js-product-gallery-carousel');
  const mainCarouselElement = document.querySelector<HTMLElement>('.js-product-main-carousel');
  if (!galleryCarouselElement || !mainCarouselElement)
    return;
  initSwiper(mainCarouselElement, {
    ...getSwiperOptions('productMain'),
    thumbs: {
      swiper: initSwiper(galleryCarouselElement, getSwiperOptions('productGallery')),
    },
  });
}

export function initCompareCarousels() {
  const productsContainer = document.querySelector<HTMLElement>('.js-compare-products');
  const attributesContainer = document.querySelector<HTMLElement>('.js-compare-attributes');
  if (!productsContainer || !attributesContainer)
    return;
  const attributesSwiper = initSwiper(attributesContainer, getSwiperOptions('productsAttributesCarouselCompare'));
  initSwiper(productsContainer, {
    ...getSwiperOptions('productsCarouselCompare'),
    on: {
      slideChange(this: Swiper) {
        if (attributesSwiper) {
          attributesSwiper.slideTo(this.activeIndex);
        }
      },
    },
  });
}
